import React from 'react';
// `useRoutes` dal modulo Datadog e non da react-router-dom: e' lo stesso hook,
// avvolto per riportare le viste come PATTERN di rotta invece che come URL
// concreti. Senza, ogni sinistro sarebbe una vista a se'. [CSP-3310]
import { useRoutes } from '@datadog/browser-rum-react/react-router-v6';
import { ErrorBoundary } from 'react-error-boundary'
import { addReactError } from '@datadog/browser-rum-react'
import Themeroutes from "./routes/Router";
import './assets/scss/style.scss';

import './datadogConfig';
/*    Handle exception version boundary */
import ErrorGeneric from './views/ErrorGeneric';
import { AuthWrapper } from './components/descope/authWrapper/AuthWrapper';
import AmChatLoader from './components/amChat/AmChatLoader';

function ErrorFallback({ error }) {
  return (
    <ErrorGeneric code={error.message} title={error.message} message={error.message} />
  )
}

/**
 * Gli errori intercettati da react-error-boundary non arrivano a Datadog da soli:
 * la boundary li ferma e l'SDK non li vede mai. `addReactError` li inoltra con lo
 * stack dei componenti. [CSP-3310]
 */
function onBoundaryError(error, info) {
  addReactError(error, info);
}

function App() {
  console.log('App', process.env.REACT_APP_SSO_LOGIN_DESCOPE_ENABLED);
  const routing = useRoutes(Themeroutes);
  // const toaster = React.createRef();

  return (
    <div className="App">
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={onBoundaryError}>
        <AuthWrapper>
          {routing}
        </AuthWrapper>
      </ErrorBoundary>

      <AmChatLoader />
    </div>
  );
}

/* without err
function App() {
  const routing = useRoutes(Themeroutes);
  return (
    <div className="App">
        {routing}
    </div>
  );
}*/

export default App;
